import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import Section from "./Section";
import Container from "./Container";
import { HtmlContent } from "./Content";
import Title from "./Title";
import { ProductList } from "./ProductList";

const CustomTilesStyles = styled.div`
  ${({ ...props }) => css`
    .content {
      margin-top: 8px;
    }

    .middle-section {
      padding-top: 0;
      padding-bottom: 0;

      ul {
        justify-content: ${props.$centerTiles ? 'center' : 'initial'}
      }
    }

    .bottom-section {
      padding-top: ${!props.$overhangMobile ? 0 : '96px'};
      margin-top: ${!props.$overhangMobile ? 0 : '-96px'};
      display: ${!props.$overhangMobile ? 'none' : 'block'}
    }

    @media (min-width: ${props.theme.breakpoints.lg}) {
      .bottom-section {
        padding-top: 96px;
        margin-top: -96px;
        display: block;
      }
    }
  `}
`;

export const CustomTiles = ({ overhang, overhangMobile, background, title, content, button, products }) => {
  const [screenWidth, setScreenWidth] = useState(0);
  const [isBottomGrey, setIsBottomGrey] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    handleResize()

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    if (screenWidth < 991) {
      if (overhangMobile === true) {
        setIsBottomGrey(background !== 'grey')
      } else {
        setIsBottomGrey(background === 'grey')
      }
    } else {
      if (overhang === true) {
        setIsBottomGrey(background !== 'grey')
      } else {
        setIsBottomGrey(background === 'grey')
      }
    }
  }, [screenWidth, overhang, overhangMobile, background]);

  return (
    <CustomTilesStyles
      $centerTiles={products?.length < 4}
      $overhangMobile={overhangMobile}
    >
      <Section grey={background === 'grey'} className="top-section">
        <Container slim style={{textAlign: 'center'}}>
          <Title title={title} classes="heading" />
          {content &&
            <div className="content">
              <HtmlContent htmlString={content} />
            </div>
          }
        </Container>
      </Section>
      <ProductList
        products={products}
        grey={background === 'grey'}
        className="middle-section"
      />
      <Section grey={isBottomGrey} className="bottom-section">
        <Container slim style={{textAlign: 'center'}}>
          {button?.url && button?.title && (
            <a href={button.url} target={button.target} className="button">
              <HtmlContent htmlString={button.title} />
            </a>
          )}
        </Container>
      </Section>
    </CustomTilesStyles>
  );
};
